// TrendByArea.jsx
import React from 'react';
import {
  ResponsiveContainer, ComposedChart, CartesianGrid, XAxis, YAxis, Tooltip, Legend, Bar, Line,
} from 'recharts';
import CustomTooltip from './CustomTooltip';
import '../plots/plots.css';
import { colorForKey } from './colors';

export function CaptureTrendByAreaChart({ data }) {
  if (!data) return null;
  return (
    <ResponsiveContainer width="100%" height="100%">
      <ComposedChart data={data.rowsForChart} margin={{ top: 8, right: 16, left: 8, bottom: 0 }}>
        <CartesianGrid stroke="#e5e7eb" vertical={false} />
        <XAxis dataKey="label" tickMargin={8} />
        <YAxis tickMargin={8} tickFormatter={(value) => value.toLocaleString()} />
        <Tooltip content={<CustomTooltip />} />
        <Legend verticalAlign="bottom" height={28} />
        {data.seriesKeys.map((key,index) => (
          <Bar key={key} dataKey={key} fill={colorForKey(key,index)} barSize={8} radius={[2,2,0,0]} />
        ))}
        <Line type="monotone" dataKey="Threshold" stroke="#d32f2f" strokeWidth={2} dot={false} name="Threshold" />
        <Line type="monotone" dataKey="Total" stroke="#1e40af" strokeWidth={2} dot={{ r: 2 }} name="Total" />
      </ComposedChart>
    </ResponsiveContainer>
  );
}

export function CaptureTrendByAreaTable({ data }) {
  if (!data) return null;

  // Utility function for formatting with commas
  const formatNumber = (num) =>
    num !== null && num !== undefined ? num.toLocaleString('en-US') : '';

  return (
    <table className="anl-ttc-table anl-table">
      <thead>
        <tr>
          <th className="col-species">Species</th>
          {data.months.map((m) => <th key={m.label}>{m.label}</th>)}
          <th>Total (per Species)</th>
        </tr>
      </thead>
      <tbody>
        {data.seriesKeys.map((sp) => (
          <tr key={sp}>
            <td className="col-species">{sp}</td>
            {data.rowsForChart.map((row) => (
              <td key={row.label} className="col-number">
                {formatNumber(row[sp] ?? 0)}
              </td>
            ))}
            <td className="col-number">
              {formatNumber(data.totalsBySpecies[sp])}
            </td>
          </tr>
        ))}
      </tbody>
      <tfoot>
        <tr className="anl-total-row">
          <td>Total (Monthly)</td>
          {data.totalsByMonth.map((m) => (
            <td key={m.month} className="col-number">
              {formatNumber(m.total)}
            </td>
          ))}
          <td className="col-number">
            {formatNumber(data.totalsByMonth.reduce((s, x) => s + x.total, 0))}
          </td>
        </tr>
        <tr className="anl-threshold-row">
          <td>Threshold (Monthly)</td>
          {data.thresholdByMonth.map((m) => (
            <td key={m.month} className="col-number">
              {formatNumber(m.value)}
            </td>
          ))}
          <td className="col-number">
            {formatNumber(data.thresholdByMonth.reduce((s, x) => s + x.value, 0))}
          </td>
        </tr>
      </tfoot>
    </table>
  );
}